<app-loader *ngIf="loaderIcon | async"></app-loader>

<span class="head_msg emailtogg" *ngIf="!isAdmin && !isCallCenterAgent" (click)="openEmailPopup(); emailPopup.emit()">
  <span class="email-icon"></span>
   <span class="notification-badge" *ngIf="counts.all > 0">
        {{ counts.all }}
    </span>

</span>
<!-- EMAIL POPUP -->
<div class="email-popup" *ngIf="isEmailPopupOpen">
  <div class="email-header">
    <h3>Email Notifications</h3>
    <button type="button" class="close text-white" (click)="cancel()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div *ngIf="EmailNotifications?.length" class="email-section-header">
    Unread
  </div>
  <div class="email-body" (scroll)="onNotificationScroll($event)">
    <div class="email-card" *ngFor="let email of EmailNotifications">
      <button type="button" class="card-close" (click)="initiateDelNotify.emit(email.Id)" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="email-left">
        <div class="icon"></div>
      </div>

      <div class="email-content">
        <b class="tenant-line">
          {{email.TenantName || 'Unknown Email'}} - {{email.From}}
        </b>
        <span>
          {{email.Subject}}
        </span>

        <small class="duration">
          {{ getTimeDisplay(email.Time) }}
        </small>

        <div class="email-bottom">
          <span class="unit-pill" *ngIf="email.UnitNumber">
            <span class="unit-icon"></span>
            Unit # {{email.UnitNumber}}
          </span>

          <div class="email-actions" (click)="openRelinkPopup(email)">
            <button> {{ (email.TenantName || email.UnitNumber) ? 'Relink' : 'Link' }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
